import React from "react";

// WECH-RB brand mark — official circular logo.
export const Seal = ({ size = 32, className = "" }) => (
  <img
    src="/wech-logo.png"
    alt="WECH-RB"
    width={size}
    height={size}
    style={{ width: size, height: size }}
    className={`flex-shrink-0 rounded-full object-cover ${className}`}
    data-testid="wech-logo"
  />
);

export default Seal;
